import content from "./content/cryptocurrency-trading.json";

export const cryptocurrencyTradingMock = {
  name: "cryptocurrency-trading",
  layoutType: 1,
  areasList: [
    {
      id: "cryptocurrency-trading-main",
      componentName: "Comp:CryptocurrencyTradingPage",
      content: JSON.stringify(content),
    },
  ],
};
